import React from "react";
import "./CMTitleSection.css";

import leftImage from "../../Assets/image-left-flag.png";
import rightImage from "../../Assets/image-right-flag.png";
import centerVideo from "../../Assets/about-pranesh.mp4"; 

export default function CMTitleSection() {
  return (
    <div className="cm-center-title-wrapper">
      <img src={leftImage} alt="Left flag" className="cm-side-image left" />
      
      <div className="cm-center-title-box">
        <video
          src={centerVideo}
          controls
          autoPlay
          loop
          muted
          className="cm-center-video"
        />
      </div>
      
      <img src={rightImage} alt="Right flag" className="cm-side-image right" />
    </div>
  );
}
